import IntegrationList from "./components/List"
import IntegrationForm from "./components/Form"

let module = "integrations"

export default [
  {
    path: "integrations",
    component: IntegrationList,
    meta: { module: module, permissions: ["Integration-access"] }
  },
  {
    path: "integrations/create",
    component: IntegrationForm,
    props: true,
    meta: { module: module, permissions: ["Integration-create"] }
  },
  {
    path: "integrations/edit/:id",
    component: IntegrationForm,
    props: true,
    meta: { module: module, permissions: ["Integration-edit"] }
  }
]
